/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelInStateDistance.ts               *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/dispatch/in-state-distance";

export class AutogenModelInStateDistance<RowType extends ModelRow> extends Endpoint<RowType, RowInStateDistanceFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowInStateDistance extends ModelRow<RowInStateDistanceFields> {
	constructor(values?: Partial<RowInStateDistanceFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowInStateDistanceFields {
	company_id: string;
	dest_city_id: number;
	distance_profile: string;
	distance_um: string;
	hazmat_type: string;
	lookup_type: string;
	method: string;
	non_toll_dist: number;
	non_toll_dist_um: string;
	origin_city_id: number;
	source: string;
	state: string;
	toll_amount: number;
	toll_amount_c: string;
	toll_amount_d: Date;
	toll_amount_n: number;
	toll_amount_r: number;
	toll_distance: number;
	toll_distance_um: string;
	city_ids: string;
	distance_profile: string;
	hazmat_type: string;
	method: string;
	source: string;
	type: string;
}

